// ============================================================================
// FUNÇÕES UTILITÁRIAS DE FORMATAÇÃO
// ============================================================================

import { CardData } from '@/types';

/**
 * Formata exibição de recursos com lookup
 */
export const formatResourcesDisplay = (data: CardData, organization: any): string => {
  if (data.quem) return data.quem;

  if (data.resources && data.resources.length > 0) {
    const resourceNames = data.resources.map(r => {
      const role = organization?.roles?.find((role: any) => role.id === r.roleId);
      return role?.name || (r as any).role || 'Definir';
    });
    
    if (data.resources.length === 1) {
      const r = data.resources[0];
      const name = resourceNames[0];
      const qty = r.quantity === 1 ? '' : ` ${r.quantity}x`;
      return `${name}${qty}`;
    } else {
      const first = resourceNames[0];
      const total = data.resources.length;
      if (total > 1) {
        return `${first} e +${total - 1}`;
      }
      return first;
    }
  }
  return data.responsavel || '-';
};

/**
 * Formata exibição de tempo
 */
export const formatTimeDisplay = (valInMinutes: number, unit: string): string => {
  if (!valInMinutes || valInMinutes === 0) return '-';
  
  const SHIFT = 480; // minutos por turno (8h)
  switch (unit) {
    case 's':
    case 'segundos':
      return `${(valInMinutes * 60).toFixed(0)}s`;
    case 'm':
    case 'minutos':
      return `${valInMinutes.toFixed(0)}min`;
    case 'h':
    case 'horas':
      return `${(valInMinutes / 60).toFixed(1)}h`;
    case 'd':
    case 'dias':
      return `${(valInMinutes / SHIFT).toFixed(2)}d`;
    case 'x/d':
    case 'vezes_dia':
      return valInMinutes > 0 ? `${(SHIFT / valInMinutes).toFixed(1)}x/d` : '-';
    default:
      return `${valInMinutes.toFixed(0)}min`;
  }
};

/**
 * Formata número com casas decimais
 */
export const formatNumber = (value: number, maxDecimals: number = 2): string => {
  if (!isFinite(value) || isNaN(value)) return '0';
  
  const rounded = parseFloat(value.toFixed(maxDecimals));
  return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(maxDecimals).replace(/\.?0+$/, '');
};
